import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center start-0 top-0",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_2 = { class: "d-block text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 h3 text-uppercase fw-bold" }, "Vehículos asociados", -1)
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 my-3"
}
const _hoisted_8 = {
  key: 0,
  class: "h3 py-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h6" }, "Chasis/VIN:", -1)
const _hoisted_10 = { class: "h3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h6" }, "Es Clasico:", -1)
const _hoisted_12 = { class: "h3" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h6" }, "VALIDADO:", -1)
const _hoisted_15 = { class: "h5 text-uppercase" }
const _hoisted_16 = { class: "col-12 my-3" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-7"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-danger fw-bold" }, " Atención: Verifique que el documento sea el correcto, NO podrá modificarlo posteriormente y será utlizado en cualquier gestion dentro del sitio web ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 my-5" }, null, -1)
const _hoisted_20 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Asociar vehiculo", -1)

import { userService } from '@/services/user.service'
import { onMounted, reactive, ref } from 'vue'
import VipUser from './form/VipUser.vue'
import FormDni from './form/FormDni.vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import { Form, useForm } from 'vee-validate'
import useLoading from '@/composables/useLoading'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormVehiculosAsociados',
  setup(__props) {

const { loading, setSearch } = useLoading(false)

const { state, commit } = useStore<VuexStore>(key)

const { handleSubmit } = useForm()

const vehiculos = ref<
  {
    id: number
    vin: string
    clasico: boolean
    validado: number
  }[]
>([])

const asociarAccion = ref(false)
const form = reactive({
  documento: state.authUser?.documento ?? '',
  documentacion: {
    vin: '',
    imagenDni: '',
    imagenLicence: '',
    imagenFirma: '',
    isClient: null
  }
})
onMounted(async () => {
  const data = await userService.vehiculosAsociados()
  vehiculos.value = data
})

const agregarVehiculoSubmit = handleSubmit(async () => {
  try {
    setSearch(true, 'Agregando Vehiculo')
    const agregado = await userService.agregarVehiculo({
      ...form.documentacion,
      documento: form.documento
    })
    if (agregado && state.authUser) {
      commit('SET_DOCUMENTO', form.documento)
      if (form.documentacion.isClient) {
        commit('SET_FIDELIZAR')
      }
    }
    return
  } finally {
    const data = await userService.vehiculosAsociados()
    vehiculos.value = data
    asociarAccion.value = false
    setSearch(false, '')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(loading).status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("h6", null, _toDisplayString(_unref(loading).text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (!asociarAccion.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm bg-light text-dark",
              type: "submit",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (asociarAccion.value = true))
            }, " Asociar nuevo vehiculo "))
          : _createCommentVNode("", true)
      ]),
      (!asociarAccion.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!vehiculos.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Todavia no hay vehículos asociados "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehiculos.value, (vehiculo) => {
              return (_openBlock(), _createElementBlock("div", {
                key: vehiculo.id,
                class: _normalizeClass([
              'd-flex my-3 px-4 py-3 justify-content-between border rounded-3',
              parseInt(vehiculo.validado.toString()) !== -1
                ? vehiculo.validado
                  ? 'bg-success text-white'
                  : 'bg-danger text-white'
                : 'bg-light'
            ])
              }, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(vehiculo.vin), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(vehiculo.clasico ? 'SI' : 'NO'), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(parseInt(vehiculo.validado.toString()) !== -1
                    ? vehiculo.validado
                      ? 'SI'
                      : 'rechazado'
                    : 'Pendiente de validación'), 1)
                ])
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_unref(Form), {
            key: 1,
            onSubmit: _unref(agregarVehiculoSubmit)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(VipUser, {
                  title: `Registra tu ${_unref(state).evento?.marca}`,
                  descripcion: `Para ser miembro de ${_unref(state).evento?.nombre} debés registrar al menos un vehículo ${_unref(state).evento?.marca} del que seas titular. Para validarlo te pedimos que completes la siguiente información.`,
                  documento: form.documento,
                  modelValue: form.documentacion,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.documentacion) = $event)),
                  required: true,
                  "no-separador": true
                }, {
                  default: _withCtx(() => [
                    (!_unref(state).authUser?.documento)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(FormDni, {
                            label: "formularios.dni.label",
                            placeholder: "formularios.dni.placeholder",
                            modelValue: form.documento,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.documento) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_18
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title", "descripcion", "documento", "modelValue"])
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn bg-light text-dark",
                  type: "submit",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (asociarAccion.value = false))
                }, " Cancelar "),
                _hoisted_21
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
    ])
  ]))
}
}

})